import * as Actions from '../constants/Wellness';

export const setWellnessEntries = entries => ({
   type: Actions.SET_WELLNESS_ENTRIES,
   payload: entries,
});

export const setWellnessLoading = loading => ({
   type: Actions.SET_WELLNESS_LOADING,
   payload: loading,
});

export const setWellnessError = error => ({
   type: Actions.SET_WELLNESS_ERROR,
   payload: error,
});

export const setSelectedDate = date => ({
   type: Actions.SET_SELECTED_DATE,
   payload: date,
});

export const setCurrentEntry = entry => ({
   type: Actions.SET_CURRENT_ENTRY,
   payload: entry,
});

export const addWellnessEntry = entry => ({
   type: Actions.ADD_WELLNESS_ENTRY,
   payload: entry,
});

export const updateWellnessEntryAction = entry => ({
   type: Actions.UPDATE_WELLNESS_ENTRY,
   payload: entry,
});

export const removeWellnessEntry = id => ({
   type: Actions.REMOVE_WELLNESS_ENTRY,
   payload: id,
});

export const setFormDraft = draft => ({
   type: Actions.SET_FORM_DRAFT,
   payload: draft,
});

export const clearFormDraft = () => ({
   type: Actions.CLEAR_FORM_DRAFT,
});
